import DeviceConfig from './DeviceConfig';
import { useContext, useMemo } from 'react';
import { ConfigContext } from '../../../../../Contexts/ConfigContext';
//mui imports====
import { Paper } from '@mui/material';
import Tab from '@mui/material/Tab';
import TabPanel from '@mui/lab/TabPanel';
//===============
import useCommonStyles from '../../../../../commonStyles';
import PageHeading from '../../../../../Components/PageHeading';
import GeneralTab from '../../../../../Components/GeneralTabAndTabContent';
import FormatDataConstants from '../constants.json';
import SwitchInput from '../../../../../Components/SwitchInput';

const { PLAYER_UI_MODES } = FormatDataConstants;

const PlayerCustomCssConfig = ({ keyData, featureDescription }) => {
	const commonStyleClasses = useCommonStyles();

	const tabListAndPanels = useMemo(() => {
		if (!keyData) return [];
		return [
			{
				tab: <Tab label="InContent" value="PLAYERUI.INCONTENT" key="PLAYERUI.INCONTENT" />,
				tabPanel: (
					<TabPanel
						value="PLAYERUI.INCONTENT"
						key="PLAYERUI.INCONTENT"
						sx={{ padding: 0, marginTop: '1.5rem' }}
					>
						<PlayerUi keyData={keyData} playerUiMode={PLAYER_UI_MODES.INCONTENT} />
					</TabPanel>
				)
			},
			{
				tab: <Tab label="Floating" value="PLAYERUI.FLOATING" key="PLAYERUI.FLOATING" />,
				tabPanel: (
					<TabPanel
						value="PLAYERUI.FLOATING"
						key="PLAYERUI.FLOATING"
						sx={{ padding: 0, marginTop: '1.5rem' }}
					>
						<PlayerUi keyData={keyData} playerUiMode={PLAYER_UI_MODES.FLOATING} />
					</TabPanel>
				)
			}
		];
	}, [keyData]);

	return (
		<Paper
			className={commonStyleClasses.mainPagePaperMarginStyle}
			style={{ paddingBottom: '2rem' }}
		>
			<PageHeading
				headingName="Player UI"
				headingPath={['Dashboard', 'Framerate', 'Format Data', 'Player UI']}
				description="Manage player position , close button and other player UI configurations here for both incontent and floating mode."
				showInfoButton = {true}
				infoMessage={featureDescription}
			/>
			<GeneralTab
				tabListAndPanels={tabListAndPanels}
				tabListStyles={{ width: 'fit-content', margin: '5rem 5rem' }}
			/>
		</Paper>
	);
};

const PlayerUi = ({ keyData, playerUiMode }) => {
	const { rawConfig, updateRawConfig } = useContext(ConfigContext); //rawConfig from ConfigContext

	const closeButtonEnabledKeyData =
		playerUiMode === PLAYER_UI_MODES.INCONTENT
			? 'formatData.inContentCloseBtnPosition.enabled'
			: null;

	return (
		<>
			<SwitchInput
				keyData={closeButtonEnabledKeyData}
				label="Close Button Enabled"
				defaultChecked={playerUiMode === PLAYER_UI_MODES.FLOATING}
				object={rawConfig}
				updateObject={updateRawConfig}
				disabled={playerUiMode === PLAYER_UI_MODES.FLOATING}
				containerStyles={{ margin: '4rem 5rem', width: 'fit-content' }}
			/>
			<DeviceConfig
				keyData={keyData + '.DESKTOP'}
				deviceName="DESKTOP"
				playerUiMode={playerUiMode}
			/>
			<DeviceConfig keyData={keyData + '.TABLET'} deviceName="TABLET" playerUiMode={playerUiMode} />
			<DeviceConfig keyData={keyData + '.MOBILE'} deviceName="MOBILE" playerUiMode={playerUiMode} />
		</>
	);
};

export default PlayerCustomCssConfig;
